import { useState } from "react";
import "../../assets/css/application.scss";

function PrivacyPage() {
  const [openSections, setOpenSections] = useState({
    "sec-1": true,
    "sec-2": true,
    "sec-3": true,
    "sec-4": true,
    "sec-5": true,
    "sec-6": true,
    "sec-7": true,
    "sec-8": true,
    "sec-9": true,
    "sec-10": true,
    "sec-11": true,
    "sec-12": true,
    "sec-13": true,
  });

  const toggleAccordion = (sectionId) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  return (
    <div className="privacy-wrap">
      <header className="privacy-header">
        <div className="brand">
          <div className="brand-logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                d="M6 12h12M6 16h8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="brand-text">
            <h1>키즈다 — 개인정보처리방침</h1>
            <p>최종 업데이트: 2026년 9월 1일</p>
          </div>
        </div>
        <a href="#toc" className="btn">
          목차 바로가기
        </a>
      </header>

      <div className="privacy-container">
        <main className="privacy-main">
          <h2 className="doc-title">개인정보처리방침</h2>
          <p className="muted" style={{ fontSize: "small" }}>
            '키즈다'(이하 ‘회사’라 함)는 고객님의 정보를 중요하게 생각하며
            아래와 같은 개인정보처리방침을 가지고 있습니다. 회사는 「개인정보
            보호법」 등 관계 법령을 준수하며 고객님의 정보가 어떤 용도와 방식으로
            사용되고 있으며 개인정보보호를 위해 어떤 조치를 취하고 있는지
            알려드립니다.
          </p>
          <br />

          {/* 제1조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-1"] ? "open" : ""
            }`}
            id="sec-1"
          >
            <button
              onClick={() => toggleAccordion("sec-1")}
              aria-expanded={openSections["sec-1"]}
            >
              제 1 조 (수집하는 개인정보 항목 및 수집방법)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                회사는 회원 가입, 서비스 제공, 기타 상담 등을 위해 최소한의
                개인정보를 수집합니다. 개인정보의 수집 내용은 아래와 같습니다.
              </p>
              <div className="table-scroll">
                <table className="policy-table">
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>수집 항목</th>
                      <th>비고</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>회원 (보호자)</td>
                      <td>
                        이름, 로그인ID, 로그인Password, 성별, 생년월일,
                        휴대폰번호(본인인증), 프로필사진, (선택) e-mail
                      </td>
                      <td>필수/선택 구분 고지</td>
                    </tr>
                    <tr>
                      <td>소셜 로그인 이용 시</td>
                      <td>
                        소셜 계정 고유 식별자(회원 식별용), (이용자가 제공에
                        동의한 범위의) 이름·e-mail
                        <span className="cell-note">
                          ※ 수집 출처: Google LLC, Apple Inc. (이용자가 소셜
                          로그인 선택 시 해당 사업자로부터 제공받음)
                        </span>
                      </td>
                      <td>소셜 가입 시에도 휴대폰 본인인증 수행</td>
                    </tr>
                    <tr>
                      <td>자녀 프로필 [2026년 10월 중 시행]</td>
                      <td>
                        이름(닉네임), 성별, 생년월일, 프로필사진(아바타)
                        <span className="cell-note">
                          ※ 아동의 아이디·비밀번호·휴대폰번호·e-mail은 수집하지
                          않으며, 법정대리인 정보는 보호자 회원 정보로
                          갈음합니다.
                        </span>
                      </td>
                      <td>최소 수집 원칙</td>
                    </tr>
                    <tr>
                      <td>기존 14세 미만 개인회원 (경과)</td>
                      <td>
                        이름, 로그인ID, 로그인Password, e-mail, 프로필사진,
                        보호자(법정대리인)의 이름과 전화번호, e-mail
                      </td>
                      <td>자녀 프로필 전환 완료 시까지 한시 유지</td>
                    </tr>
                    <tr>
                      <td>자동 수집</td>
                      <td>
                        기기정보(기기 식별자·OS·앱 버전), 접속 로그, 서비스 이용
                        기록, (자녀 기기 연결 시) 연결 기기 식별 정보 및 연결
                        이력
                      </td>
                      <td>서비스 이용 과정에서 생성·수집</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  개인정보 수집방법: 키즈다 애플리케이션
                </li>
              </ul>
            </div>
          </section>

          {/* 제2조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-2"] ? "open" : ""
            }`}
            id="sec-2"
          >
            <button
              onClick={() => toggleAccordion("sec-2")}
              aria-expanded={openSections["sec-2"]}
            >
              제 2 조 (개인정보의 수집 및 이용목적)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                <strong>
                  1. 서비스 제공에 관한 계약이행 및 서비스 제공에 따른 요금정산
                </strong>
              </p>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  AI 서비스 제공 및 서비스의 성능과 알고리즘 개선, 콘텐츠 제공,
                  청구서 발송, 본인인증, 물품배송, 구매 및 요금결제, 금융서비스
                </li>
              </ul>
              <p style={{ fontSize: "small" }}>
                <strong>2. 회원관리</strong>
              </p>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  회원제 서비스 이용에 따른 본인 확인, 개인식별, 소셜 로그인
                  계정 인증 및 회원 식별, 불량회원의 부정 이용 방지와 비인가
                  사용방지, 가입 의사 및 연령 확인, 만 14세 미만 아동의
                  개인정보 수집 시 법정대리인 동의여부 확인(보호자 본인인증
                  기반), 불만처리 등 민원처리, 고지사항 전달
                </li>
              </ul>
              <p style={{ fontSize: "small" }}>
                <strong>3. 가족 계정 운영</strong>
              </p>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  자녀 프로필의 생성·관리, 구독 혜택의 자녀 프로필 공유, 자녀
                  기기 연결의 등록·해제 및 부정 이용 방지, 연령별 콘텐츠 제공
                </li>
              </ul>
              <p style={{ fontSize: "small" }}>
                <strong>4. 서비스 안내 등 마케팅 및 광고</strong>
              </p>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  신규 서비스 개발 및 특화, 인구통계학적 특성에 따른 서비스 제공
                  및 광고게재, 접속 빈도 파악, 회원의 서비스 이용에 대한 통계,
                  이벤트 등 광고성 정보 전달
                </li>
              </ul>
            </div>
          </section>

          {/* 제3조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-3"] ? "open" : ""
            }`}
            id="sec-3"
          >
            <button
              onClick={() => toggleAccordion("sec-3")}
              aria-expanded={openSections["sec-3"]}
            >
              제 3 조 (개인정보 수집에 대한 동의)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                회사는 회원님의 개인정보 수집에 대하여 동의를 받고 있으며,
                회원가입 절차 중 이용약관 및 개인정보처리방침에 동의절차를
                마련해 두고 있습니다. 만 14세 미만 아동의 개인정보는
                법정대리인(보호자 회원)의 동의를 받아 수집하며, 동의 방식은
                제11조에 따릅니다.
              </p>
            </div>
          </section>

          {/* 제4조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-4"] ? "open" : ""
            }`}
            id="sec-4"
          >
            <button
              onClick={() => toggleAccordion("sec-4")}
              aria-expanded={openSections["sec-4"]}
            >
              제 4 조 (개인정보의 이용 현황)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                회사는 이용자들의 개인정보를 제2조에서 고지한 범위 내에서
                사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나
                원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만,
                이용자들이 사전에 공개에 동의한 경우, 법령의 규정에 의거하거나
                수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가
                있는 경우에는 예외로 합니다.
              </p>
            </div>
          </section>

          {/* 제5조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-5"] ? "open" : ""
            }`}
            id="sec-5"
          >
            <button
              onClick={() => toggleAccordion("sec-5")}
              aria-expanded={openSections["sec-5"]}
            >
              제 5 조 (개인정보의 제3자 제공 및 처리 위탁 현황)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                ① 회사는 키즈다 앱의 뉴스 콘텐츠 및 이벤트 제공 업무를 외부 위탁
                없이 직접 총괄하여 수행합니다. 종전 수탁업체 (주)동아이지에듀에
                대한 개인정보 처리 위탁은 종료되었으며, 위탁 종료에 따라
                수탁업체가 보유한 관련 개인정보는 위·수탁 계약 및 관계 법령에
                따라 반환·파기됩니다.
              </p>
              <p style={{ fontSize: "small" }}>
                ② 위탁업무: STT 변환 AI 서비스 제공 및 서비스의 성능, 알고리즘
                개선 목적
                <br />
                위탁범위: 키즈다 앱 키즈 루틴 음성일기 서비스
                <br />
                위탁기간: 해당 AI 서비스 종료 시까지
                <br />
                수탁업체: OpenAI OpCo, LLC
              </p>
              <p style={{ fontSize: "small" }}>
                ③ 회사는 고객님의 동의 없이 고객님의 정보를 제3자에게 제공하지
                않습니다. 향후 그러한 필요가 생길 경우, 고객님에게 통지하고
                필요한 경우 사전 동의를 받도록 하겠습니다.
              </p>
            </div>
          </section>

          {/* 제6조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-6"] ? "open" : ""
            }`}
            id="sec-6"
          >
            <button
              onClick={() => toggleAccordion("sec-6")}
              aria-expanded={openSections["sec-6"]}
            >
              제 6 조 (개인정보의 보유 및 이용 기간)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                1. 서비스 이용자가 당사의 회원으로서 서비스를 계속 이용하는 동안
                당사는 이용자의 개인정보를 계속 보유하며 서비스 제공 등을 위해
                이용합니다. 개인정보는 수집 및 이용 목적이 달성되거나 이용자가
                직접 삭제 또는 회원 탈퇴한 경우 재생할 수 없는 방법으로
                파기합니다.
              </p>
              <p style={{ fontSize: "small" }}>
                <strong>2. 자녀 프로필 삭제 시:</strong> 해당 프로필의 개인정보
                및 활동 정보(포인트·루틴·채점이력 등)는 회원의 복구 요청에
                대비하여 삭제일로부터 30일간 보관 후 파기합니다. 보관 기간 중에는
                다른 목적으로 이용하지 않습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                <strong>3. 기존 자녀 계정의 프로필 전환 시:</strong> 보호자
                승인에 따라 기존 자녀 계정의 개인정보 및 이용 정보는 자녀 프로필로
                승계되며, 전환 유예기간(기능 적용일로부터 90일) 종료 후 미전환
                계정은 휴면·파기 절차에 따라 처리됩니다.
              </p>
              <p style={{ fontSize: "small" }}>
                <strong>4. 회원 탈퇴 시 보존:</strong> 불량 이용자의 재가입 방지,
                명예훼손 등 권리침해 분쟁 및 수사협조를 위해 회원탈퇴 후 1년간
                보관할 수 있습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                <strong>5. 관련 법령에 의한 보존:</strong>
              </p>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  계약 또는 청약철회 등에 관한 기록(5년), 대금결제 및 재화 등의
                  공급에 관한 기록(5년), 소비자의 불만 또는 분쟁처리에 관한
                  기록(3년) — 전자상거래 등에서의 소비자보호에 관한 법률
                </li>
                <li style={{ fontSize: "small" }}>
                  본인확인에 관한 기록(6개월), 방문에 관한 기록(3개월) —
                  정보통신망 이용촉진 및 정보보호 등에 관한 법률
                </li>
              </ul>
            </div>
          </section>

          {/* 제7조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-7"] ? "open" : ""
            }`}
            id="sec-7"
          >
            <button
              onClick={() => toggleAccordion("sec-7")}
              aria-expanded={openSections["sec-7"]}
            >
              제 7 조 (개인정보의 파기절차 및 방법)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                회원님은 언제든지 등록되어 있는 개인정보를 열람하거나 정정하실 수
                있으며, 회원 탈퇴를 요청하실 수 있습니다.
              </p>
              <span style={{ fontSize: "small" }}>
                <strong>파기절차</strong>
              </span>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  이용자가 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부
                  방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간
                  저장된 후 파기됩니다.
                </li>
              </ul>
              <span style={{ fontSize: "small" }}>
                <strong>파기방법</strong>
              </span>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>
                  종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
                  파기하며, 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수
                  없는 기술적 방법을 사용하여 삭제합니다.
                </li>
              </ul>
            </div>
          </section>

          {/* 제8조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-8"] ? "open" : ""
            }`}
            id="sec-8"
          >
            <button
              onClick={() => toggleAccordion("sec-8")}
              aria-expanded={openSections["sec-8"]}
            >
              제 8 조 (이용자 및 법정대리인의 권리와 그 행사방법)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                1. 이용자 및 법정대리인은 언제든지 등록되어 있는 자신 혹은 당해
                만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며
                가입해지를 요청할 수 있습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                2. 자녀 프로필의 개인정보는 보호자 회원이 앱 내 [My &gt; 자녀
                프로필 관리]에서 직접 열람·수정·삭제할 수 있습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                3. 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면
                지체 없이 조치하겠습니다. 이용자가 개인정보의 오류에 대한 정정을
                요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는
                제공하지 않습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                4. 이용자는 정보주체로서 관련 법령에 의거, 개인정보의 열람,
                정정·삭제, 처리정지 요구를 할 수 있으며, 회사는 이에 대해 10일
                이내에 조치를 통지합니다.
              </p>
            </div>
          </section>

          {/* 제9조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-9"] ? "open" : ""
            }`}
            id="sec-9"
          >
            <button
              onClick={() => toggleAccordion("sec-9")}
              aria-expanded={openSections["sec-9"]}
            >
              제 9 조 (개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                쿠키(cookie)는 HTTP 서버에서 사용자 브라우저에게 보내는 조그마한
                데이터 파일로써 회원님의 컴퓨터에 저장됩니다. 회원님은 웹브라우저
                옵션을 통해 쿠키 저장을 허용·확인·거부할 수 있으며, 저장을 거부할
                경우 로그인이 필요한 서비스 이용에 제한이 있을 수 있습니다.
              </p>
            </div>
          </section>

          {/* 제10조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-10"] ? "open" : ""
            }`}
            id="sec-10"
          >
            <button
              onClick={() => toggleAccordion("sec-10")}
              aria-expanded={openSections["sec-10"]}
            >
              제 10 조 (개인정보보호를 위한 기술적, 관리적 대책)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                해킹 방지를 위한 방화벽·보안시스템 운영, 개인정보 송수신 시 SSL
                보안서버 인증서 적용, 개인정보 접근 권한의 최소화, 개인정보처리자
                정기 교육, 개인정보처리시스템 접속 기록 유지 및 정기 점검,
                출력·복사 시 보호조치 등 현행과 동일하게 시행합니다.
              </p>
            </div>
          </section>

          {/* 제11조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-11"] ? "open" : ""
            }`}
            id="sec-11"
          >
            <button
              onClick={() => toggleAccordion("sec-11")}
              aria-expanded={openSections["sec-11"]}
            >
              제 11 조 (아동의 개인정보)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                1. 회사는 만 14세 미만 아동의 개인정보를 최소한으로 수집하며,
                아동 명의의 독립 계정은 제공하지 않습니다. [2026년 10월 중 시행]
              </p>
              <p style={{ fontSize: "small" }}>
                2. 만 14세 미만 아동의 개인정보는 법정대리인(보호자 회원)이
                휴대폰 본인인증을 완료한 계정에서 자녀 프로필 형태로 직접
                등록하며, 등록 과정에서 법정대리인의 동의를 받고 동의 일시를
                기록·보관합니다.
              </p>
              <p style={{ fontSize: "small" }}>
                3. 법정대리인은 아동의 개인정보에 대한 열람·정정·삭제를 제8조
                제2항의 방법으로 언제든지 행사할 수 있습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                4. 회사는 어떠한 경우에도 전화나 E-mail을 통해 사용자의
                비밀번호를 묻지 않습니다. 비밀번호 및 보호자 PIN이 제3자에게
                노출되지 않도록 유의하시기 바랍니다.
              </p>
            </div>
          </section>

          {/* 제12조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-12"] ? "open" : ""
            }`}
            id="sec-12"
          >
            <button
              onClick={() => toggleAccordion("sec-12")}
              aria-expanded={openSections["sec-12"]}
            >
              제 12 조 (개인정보 보호책임자)
            </button>
            <div data-panel>
              <ul className="clean">
                <li style={{ fontSize: "small" }}>이름: 김준영</li>
                <li style={{ fontSize: "small" }}>연락처: 02-3288-3455</li>
                <li style={{ fontSize: "small" }}>
                  E-Mail: kidsda@wegocompany.net
                </li>
              </ul>
              <br />
              <p style={{ fontSize: "small" }}>
                이용자는 개인정보침해신고센터(privacy.kisa.or.kr / 국번없이 118),
                대검찰청 사이버범죄수사단(www.spo.go.kr / 국번없이 1301), 경찰청
                사이버안전국(cyberbureau.police.go.kr / 국번없이 182)에 개인정보
                침해에 대한 피해구제, 상담 등을 문의할 수 있습니다.
              </p>
            </div>
          </section>

          {/* 제13조 */}
          <section
            className={`policy-section accordion ${
              openSections["sec-13"] ? "open" : ""
            }`}
            id="sec-13"
          >
            <button
              onClick={() => toggleAccordion("sec-13")}
              aria-expanded={openSections["sec-13"]}
            >
              제 13 조 (부칙)
            </button>
            <div data-panel>
              <p style={{ fontSize: "small" }}>
                1. 현 개인정보처리방침은 2026년 9월 1일부터 적용됩니다. 다만
                제1조의 자녀 프로필 수집 항목, 제2조 제3호, 제6조 제2항·제3항,
                제8조 제2항 및 제11조의 개정 사항은 회원 구조 개편 기능이 적용되는
                2026년 10월 중 별도 고지하는 날부터 적용됩니다.
              </p>
              <p style={{ fontSize: "small" }}>
                1-2. (v2.1) 제5조의 개정 사항(뉴스 콘텐츠·이벤트 제공 업무의 직접
                수행 및 (주)동아이지에듀 위탁 종료)은 2026년 9월 1일부터
                적용됩니다. (공고일: 2026년 8월 6일 — 고지 기간 28일)
              </p>
              <p style={{ fontSize: "small" }}>
                2. 이전 개인정보처리방침(2025년 9월 29일 시행)은 개정 방침 적용
                전까지 적용되며, 앱 내에서 확인할 수 있습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                3. 개인정보처리방침의 수정, 변경이 있을 시 최소 7일 이전(수집
                항목·이용 목적 등 중요한 변경은 30일 이전)에 키즈다 앱 내 공지를
                통하여 고지할 것입니다.
              </p>
            </div>
          </section>
        </main>

        <aside id="toc" className="privacy-aside">
          <nav className="toc">
            <h4>문서 목차</h4>
            <ul>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-1">제 1 조 (수집하는 개인정보 항목 및 수집방법)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-2">제 2 조 (개인정보의 수집 및 이용목적)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-3">제 3 조 (개인정보 수집에 대한 동의)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-4">제 4 조 (개인정보의 이용 현황)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-5">
                  제 5 조 (개인정보의 제3자 제공 및 처리 위탁 현황)
                </a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-6">제 6 조 (개인정보의 보유 및 이용 기간)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-7">제 7 조 (개인정보의 파기절차 및 방법)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-8">
                  제 8 조 (이용자 및 법정대리인의 권리와 그 행사방법)
                </a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-9">
                  제 9 조 (개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항)
                </a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-10">
                  제 10 조 (개인정보보호를 위한 기술적, 관리적 대책)
                </a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-11">제 11 조 (아동의 개인정보)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-12">제 12 조 (개인정보 보호책임자)</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-13">제 13 조 (부칙)</a>
              </li>
            </ul>
          </nav>
        </aside>
      </div>
    </div>
  );
}

export default PrivacyPage;
